import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import LogoLoader from '../component/logo/LogoLoader';

const channelConfig = {
  SMS: {
    label: 'SMS',
    icon: '💬',
    note: 'SMS credits are used for sending text messages to members.',
    comingSoon: false,
  },
  WHATSAPP: {
    label: 'WhatsApp',
    icon: '📱',
    note: 'WhatsApp credits are used for sending WhatsApp messages to members.',
    comingSoon: false,
  },
  EMAIL: {
    label: 'Email',
    icon: '✉️',
    note: 'Email channel is coming soon.',
    comingSoon: true,
  },
};

function Credits() {
  const [searchParams] = useSearchParams();
  const memberId = searchParams.get('id');

  const [member, setMember] = useState(null);
  const [selectedChannel, setSelectedChannel] = useState('SMS');
  const [plans, setPlans] = useState([]);
  const [filterPlans, setFilterPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [plansLoading, setPlansLoading] = useState(false);

  // 1. Fetch member info
  useEffect(() => {
    const fetchMember = async () => {
      try {
        const res = await axios.get(`/api/getMemberInfo?id=${memberId}&credits=true`);
        setMember({
          name: res.data.name,
          email: res.data.email,
        });
        setPlans(res.data.creditPlans);
      } catch (err) {
        alert('Member not found');
       /* const userfallback = {"name":"Module3","email":"module3@membermeld.com","planEndDate":"2027-02-07","creditPlans":[{"id":"6ryqPKKK48mnl2twpqv5","tag":"Basic","credits":250,"amount":199,"channel":"SMS"},{"id":"7zhr104T7x78xwgu5kVE","tag":"Business","credits":1000,"channel":"SMS","amount":599},{"id":"SH0UR9JjQiFyOFdePXKW","tag":"Starter","credits":100,"amount":99,"channel":"SMS"},{"id":"XrhxsJULpFZu6EpPkcqF","channel":"SMS","credits":500,"tag":"Popular","amount":349},{"id":"cOIuUcskikFJUH0Gf6gM","tag":"Starter","amount":149,"channel":"WHATSAPP","credits":100},{"id":"mXZJzQgSPWP8mMtceSSx","channel":"WHATSAPP","tag":"Basic","credits":250,"amount":299},{"id":"vSwAasM74JiRe4rSEiX2","channel":"WHATSAPP","tag":"Business","credits":1000,"amount":999},{"id":"zfh3NwV7GHjSloHS05jJ","credits":500,"tag":"Popular","channel":"WHATSAPP","amount":549}]};
        setMember({
          name: userfallback.name,
          email: userfallback.email,
        });
        setPlans(userfallback.creditPlans);*/
      }
    };

    if (memberId) fetchMember();
  }, [memberId]);

  useEffect(() => {
  
  if (!channelConfig[selectedChannel]?.comingSoon) {
      setFilterPlans(
      plans.filter(
        (plan) => plan.channel === selectedChannel
      )
    );
    } else {
      setFilterPlans([]);
      setSelectedPlan(null);
    }
}, [selectedChannel, plans]);

  // 2. Fetch plans when channel changes
  /*useEffect(() => {
    const fetchPlans = async () => {
      setPlansLoading(true);
      setSelectedPlan(null);
      try {
        const res = await axios.get(`/api/getCreditPlans?channel=${selectedChannel}`);
        const sorted = res.data.plans.sort((a, b) => a.credits - b.credits);
        setPlans(sorted);
      } catch (err) {
        // Fallback demo plans if API not ready
        const fallback = {
          sms: [
            { id: 'sms_500', credits: 500, amount: 199, tag: null },
            { id: 'sms_1000', credits: 1000, amount: 349, tag: 'Best Seller' },
            { id: 'sms_2500', credits: 2500, amount: 799, tag: 'Recommended' },
            { id: 'sms_5000', credits: 5000, amount: 1399, tag: null },
          ],
          whatsapp: [
            { id: 'wa_250', credits: 250, amount: 149, tag: null },
            { id: 'wa_500', credits: 500, amount: 269, tag: 'Best Seller' },
            { id: 'wa_1500', credits: 1500, amount: 699, tag: 'Recommended' },
            { id: 'wa_3000', credits: 3000, amount: 1199, tag: null },
          ],
          email: [],
        };
        setPlans(fallback[selectedChannel] || []);
      } finally {
        setPlansLoading(false);
      }
    };

    if (!channelConfig[selectedChannel]?.comingSoon) {
      fetchPlans();
    } else {
      setPlans([]);
      setSelectedPlan(null);
    }
  }, [selectedChannel]);
*/
  const handleChannelSelect = (channel) => {
    if (channelConfig[channel]?.comingSoon) return;
    setSelectedChannel(channel);
  };

  const handleBuyNow = async () => {
    if (!selectedPlan) return alert('Please select a credit plan');
    setLoading(true);
    console.log(selectedPlan);
    try {
      const res = await axios.post(`/api/createPaymentLink`, {
        memberId:memberId,
        plan: selectedPlan,
        channel: selectedChannel,
        type: 'credits',
      });
      window.location.href = res.data.short_url;
    } catch (err) {
      alert('Error creating payment link');
    } finally {
      setLoading(false);
    }
  };

  const pricePerCredit = selectedPlan
    ? (selectedPlan.amount / selectedPlan.credits).toFixed(2)
    : null;

  if (!member) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LogoLoader theme="light" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-4 flex flex-col items-center">

      {/* Header */}
      <header className="container flex flex-col md:flex-row items-center justify-center bg-white mb-2">
        <div>
          <img src="header_logo.svg" alt="Logo" className="h-20 w-80" />
        </div>
      </header>

      {/* Member Info */}
      <h2 className="text-2xl font-bold mb-2 mt-8">Hello, {member.name}</h2>
      <label className="text-gray-600 mb-6">{member.email}</label>

      {/* Channel Selection */}
      <h3 className="text-xl font-semibold mb-4">Choose channel</h3>

      <div className="flex overflow-x-auto gap-4 py-2 w-full justify-center-safe mb-2">
        {Object.entries(channelConfig).map(([key, config]) => (
          <div
            key={key}
            onClick={() => handleChannelSelect(key)}
            className={`flex flex-col items-start p-4 rounded-lg min-w-[130px] flex-shrink-0 relative gap-2
              ${config.comingSoon
                ? 'bg-gray-100 opacity-60 cursor-not-allowed'
                : selectedChannel === key
                  ? 'bg-[#d0eeff] border-2 border-[#00A6FB] cursor-pointer'
                  : 'bg-[#E6F4FF] border-2 border-transparent cursor-pointer'
              }`}
          >
            {config.comingSoon && (
              <span className="absolute top-2 right-2 text-[9px] px-2 py-1 rounded font-bold bg-yellow-100 text-yellow-800 border border-yellow-400">
                Soon
              </span>
            )}
            <span className="text-2xl">{config.icon}</span>
            <span className="font-bold text-sm">{config.label}</span>
          </div>
        ))}
      </div>

      <p className="text-sm text-gray-500 mb-6 text-center">
        {channelConfig[selectedChannel].note}
      </p>

      {/* Credit Plans */}
      <h3 className="text-xl font-semibold mb-4">Choose credits</h3>

      {plansLoading ? (
        <p className="text-gray-400 mb-6">Loading plans...</p>
      ) : plans.length === 0 ? (
        <p className="text-gray-400 mb-6">No plans available for this channel yet.</p>
      ) : (
        <div className="flex overflow-x-auto gap-4 py-2 w-full justify-center-safe mb-2">
          {filterPlans.map((plan) => (
            <div
              key={plan.id}
              onClick={() => setSelectedPlan(plan)}
              className={`flex flex-col items-start p-4 rounded-lg min-w-[145px] flex-shrink-0 relative gap-2 cursor-pointer
                ${selectedPlan?.id === plan.id
                  ? 'bg-[#d0eeff] border-2 border-[#00A6FB]'
                  : 'bg-[#E6F4FF] border-2 border-transparent'
                }`}
            >
              {/* Tag */}
              <div className="flex items-center w-full">
                <input
                  type="radio"
                  name="creditPlan"
                  id={plan.id}
                  checked={selectedPlan?.id === plan.id}
                  onChange={() => setSelectedPlan(plan)}
                  className="mr-auto"
                />
                {plan.tag && (
                  <span
                    className={`text-[10px] px-2 py-1 rounded ml-auto font-bold border
                      ${plan.tag === 'Recommended'
                        ? 'bg-green-100 text-green-600 border-green-500'
                        : 'bg-blue-100 text-blue-600 border-blue-400'
                      }`}
                  >
                    {plan.tag}
                  </span>
                )}
              </div>

              <label htmlFor={plan.id} className="font-bold cursor-pointer text-sm">
                {plan.credits.toLocaleString()} credits
              </label>
              <label htmlFor={plan.id} className="cursor-pointer text-sm">
                ₹{plan.amount}
              </label>
              <span className="text-[11px] text-[#00A6FB]">
                ₹{(plan.amount / plan.credits).toFixed(2)} / credit
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Billing Summary */}
      <div className="bg-white p-8 rounded-2xl shadow-lg max-w-md w-full mt-8 text-center">
        <h2 className="text-2xl flex font-semibold mb-6">
          You will be billed:{' '}
          <span className="text-3xl font-bold ml-2">
            {selectedPlan ? `₹ ${selectedPlan.amount}` : '—'}
          </span>
        </h2>

        <div className="flex flex-col gap-3 text-left mb-4">
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Channel</span>
            <span className="font-semibold">{channelConfig[selectedChannel].label}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Credits</span>
            <span className="font-semibold">
              {selectedPlan ? `${selectedPlan.credits.toLocaleString()} credits` : '—'}
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Price per credit</span>
            <span className="font-semibold">
              {pricePerCredit ? `₹${pricePerCredit}` : '—'}
            </span>
          </div>
          <hr className="border-gray-100" />
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Total amount</span>
            <span className="font-bold text-base">
              {selectedPlan ? `₹${selectedPlan.amount}` : '—'}
            </span>
          </div>
        </div>
      </div>

      {/* Buy Button */}
      <button
        onClick={handleBuyNow}
        disabled={loading || !selectedPlan}
        className="mt-6 bg-[#00A6FB] hover:bg-[#0095e0] text-white font-semibold py-3 px-8 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? 'Processing...' : 'Buy Credits'}
      </button>
    </div>
  );
}

export default Credits;
